var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mt-1 mb-1",staticStyle:{"width":"100%"}},[_c('video',{ref:"videoPlayer",staticClass:"video-js",staticStyle:{"width":"100%","height":"auto"},attrs:{"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }